function getBugsnagClient() {
    return window.bugsnagClient || null;
}

export function notifyBugsnag(error) {
    const client = getBugsnagClient();
    if (client) {
        client.notify(error);
    } else {
        console.error("Bugsnag not configured");
        console.error(error);
    }
}



// WEBPACK FOOTER //
// ./src/utils/bugsnag.js